import { LOGIN_PENDING, LOGIN_SUCCESS, LOGIN_ERROR } from './types';
import { login as loginAPI, getMe as getMeAPI } from '../../service/apis';

const loginPending = () => {
  return {
    type: LOGIN_PENDING,
  }
}

const loginSuccess = (user: any) => {
  return {
    type: LOGIN_SUCCESS,
    user: user,
  }
}

const loginError = () => {
  return {
    type: LOGIN_ERROR,
  }
}

export const setAuth = (user: any) => {
  return (dispatch: any) => {
    dispatch(loginSuccess(user));
  }
}

// reload the session from the API on page load, so changed user/tenant settings apply without a new login
export const refreshAuth = (tokenUser: any) => {
  return (dispatch: any) => {
    dispatch(loginPending());

    getMeAPI().then(
      (res: any) => {
        localStorage.setItem('jwt', res.jwt);
        dispatch(loginSuccess(res.user));
      }).catch((error: any) => {
        // expired token / deleted user (401) is handled by the axios interceptor (redirect to login);
        // API unreachable etc.: carry on with the data from the stored token
        console.log(error);
        dispatch(loginSuccess(tokenUser));
      });
  }
}

export const logout = () => {
  localStorage.removeItem('jwt');
  window.location.reload();
}

export const login = (username: string, password: string) => {
  return (dispatch: any) => {
    dispatch(loginPending());

    loginAPI(username, password).then(
      (res: any) => {
        if (!res || !res.jwt) {
          console.error('Login failed: no JWT received');
          dispatch(loginError());
          return;
        }

        localStorage.setItem('jwt', res.jwt);
        dispatch(loginSuccess(res.user));
        window.location.replace(new URL('/', window.location.href).href);
      }).catch((error: any) => {
        console.log(error);
        dispatch(loginError());
      });
  }
}
